/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Hidden from "@material-ui/core/Hidden";
import CloseIcon from "@material-ui/icons/Close";
import * as moment from "moment";
import Checkbox from "@material-ui/core/Checkbox";
import { connect } from "react-redux";
import { ThemeActionButton } from "../../../shared/widgets";
import "./EditContractPage.css";
import { setNotificationMessage } from "../../../redux/actions/notificationAction";
import { markEditContractAction } from "../../../redux/action-creators/collectionActionCreator";
import { MessageType } from "../../../Constant";

function EditContractPage(props) {
  const {
    details, initiateNotification, markCollection, closeEditModal,
  } = props;
  const [inputData, setInputData] = useState({});
  useEffect(() => {
    setInputData(details.contract.map((detail) => (
      {
        contractType: detail.type,
        contractAmount: detail.amount,
        inputAmount: detail.amount,
        isAmountNotValid: false,
      }
    )));
  }, [details]);

  const contractDetail = {
    flatFeeShare: "Flat Fee ",
    revenueShare: "Revenue Share",
    bgShare: "Business Guarantee",
    baselineShare: "BaseLine",

  };

  const handleAmountOrCheckboxChange = (value, contract, isAmount, isCheckbox) => {
    if (isAmount) contract.inputAmount = value;
    if (isCheckbox) {
      contract.isAmountNotValid = value;
      contract.inputAmount = value ? 0 : contract.inputAmount;
    }
    setInputData(
      (prevState) => prevState.map((p) => (
        p.contractType === contract.contractType ? Object.assign(p, contract) : p
      )),
    );
  };

  const showNotification = (type, msg) => {
    initiateNotification({
      type,
      message: msg || "Something went wrong",
    });
  };
  const handleSubmitChange = () => {
    if (inputData.find((item) => item.isAmountNotValid === false && item.inputAmount === "")) {
      showNotification(MessageType.ERROR, "Please make the changes in all the field");
      return;
    }
    const selectedData = {
      busNumber: details.busNumber,
      fromDate: parseFloat(moment(new Date(details.fromDate)).format("x")),
    };
    const updates = inputData.map((item) => ({
      type: item.contractType,
      modified_amount: item.inputAmount,
    }));
    markCollection({
      selectedData,
      updates,
    }, "gridLoader");
    closeEditModal();
  };

  return (
    <Dialog
      onClose={() => closeEditModal()}
      aria-labelledby="customized-dialog-title"
      open
      className="dialogWrapper"
    >
      <DialogTitle id="customized-dialog-title" onClose={() => closeEditModal()}>
        <div className="modalHeaderWrapper">
          <Hidden only={["sm", "xs"]}>
            <div className="dialogTitle">Contract Details</div>
            <div className="dialogTitle">{`Vehicle - ${details.busNumber}`}</div>
          </Hidden>
          <Hidden only={["lg", "xl", "md"]}>
            <div className="dialogTitle">{`${details.busNumber} Details`}</div>
          </Hidden>
          <div className="btnWrapper">
            <div
              role="button"
              className="closeIcon"
              onClick={() => closeEditModal()}
              onKeyDown={() => { /* onKeyDown */ }}
              tabIndex="0"
              aria-label="close"
            >
              <CloseIcon />
            </div>
          </div>
        </div>
      </DialogTitle>
      <DialogContent dividers className="detailWrapper">
        {inputData.length === 0 && (
          <div className="error-no-data">
            No data on contract to show
          </div>
        )}
        {inputData
                    && inputData.length > 0
                    && (
                      <>
                        <div className="sub-heading">
                          <span>Terms</span>
                        </div>
                        <div className="sub-container">
                          <div className="detailrow">
                            <div>Period</div>
                            {" "}
                            <div>
                              {`${moment(details.fromDate).format("DD MMM YYYY")}`}
                            </div>
                          </div>
                        </div>

                        {
                          inputData.map((raw, index) => {
                            const labelId = `transfer-list-all-item-${index}-label`;
                            return (
                              <div key={index} className="edit-contract-page">
                                <div className="sub-heading">
                                  <span>Commercials</span>
                                </div>
                                <div className="sub-container">
                                  <div className="container-wrapper">
                                    <div className="contract-detail">
                                      {raw.contractType && (
                                        <div className="detailrow">
                                          <div>Contract Type</div>
                                          <div>{contractDetail[raw.contractType]}</div>
                                        </div>
                                      )}
                                      <div className="detailrow">
                                        <div>Contract Amount</div>
                                        <div>{raw.contractAmount}</div>
                                      </div>
                                    </div>
                                    <div>
                                      <div>
                                        <Checkbox
                                          onChange={(e) => {
                                            handleAmountOrCheckboxChange(
                                              e.target.checked,
                                              raw,
                                              false,
                                              true,
                                            );
                                          }}
                                          inputProps={{ "aria-labelledby": labelId }}
                                        />
                                        Select the checkbox to make the amount 0
                                      </div>
                                      <div className="contract-number">
                                        <input
                                          type="number"
                                          className={`form-control ${raw.isAmountNotValid === false && raw.inputAmount === "" ? "red-input-block" : ""}`}
                                          disabled={(raw.isAmountNotValid) ? "disabled" : ""}
                                          placeholder="Amount"
                                          onChange={(e) => {
                                            handleAmountOrCheckboxChange(
                                              e.target.value,
                                              raw,
                                              true,
                                              false,
                                            );
                                          }}
                                          value={raw.inputAmount}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        }
                        <div className="footer-submit-btn sub-heading">
                          <ThemeActionButton
                            onClick={() => handleSubmitChange()}
                            buttonText="Submit"
                          />
                        </div>
                      </>
                    )}
      </DialogContent>

    </Dialog>
  );
}
const mapDispatchToProps = (dispatch) => ({
  initiateNotification: (value) => (dispatch(setNotificationMessage(value))),
  markCollection: (params, loaderScope) => {
    dispatch(markEditContractAction(params, loaderScope));
  },
});

export default connect(null, mapDispatchToProps)(EditContractPage);
